import { useEffect, useRef, useState } from 'react';
import { IParsedImage } from '@components/typescript';
import { IProductPremiumArrangementVariantBlock, IProductPremiumDescriptionVariantBlock, IProductPremiumProductDescriptionVariantBlock, IProductPremiumSingleBlock } from '@features/cms/typescript';
const isDescriptionVariant = (item: IProductPremiumSingleBlock<IProductPremiumDescriptionVariantBlock | IProductPremiumArrangementVariantBlock | IProductPremiumProductDescriptionVariantBlock, IParsedImage>): item is IProductPremiumSingleBlock<IProductPremiumDescriptionVariantBlock, IParsedImage> => item?.variant?.type === 'description';
const isArrangementVariant = (item: IProductPremiumSingleBlock<IProductPremiumDescriptionVariantBlock | IProductPremiumArrangementVariantBlock | IProductPremiumProductDescriptionVariantBlock, IParsedImage>): item is IProductPremiumSingleBlock<IProductPremiumArrangementVariantBlock, IParsedImage> => item?.variant?.type === 'arrangement';
const isProductDescriptionVariant = (item: IProductPremiumSingleBlock<IProductPremiumDescriptionVariantBlock | IProductPremiumArrangementVariantBlock | IProductPremiumProductDescriptionVariantBlock, IParsedImage>): item is IProductPremiumSingleBlock<IProductPremiumProductDescriptionVariantBlock, IParsedImage> => item?.variant?.type === 'productDescription';
const useProductPremiumSlide = (blocks: IProductPremiumSingleBlock<IProductPremiumDescriptionVariantBlock | IProductPremiumArrangementVariantBlock | IProductPremiumProductDescriptionVariantBlock, IParsedImage>[], activeBlock: number) => {
  const [previousBlock, setPreviousBlock] = useState(blocks[activeBlock]);
  const [currentBlock, setCurrentBlock] = useState(blocks[activeBlock]);
  const prevBlockRef = useRef(blocks[activeBlock]);
  useEffect(() => {
    const prevBlock = prevBlockRef.current;
    setPreviousBlock(prevBlock);
    prevBlockRef.current = blocks[activeBlock];
    setCurrentBlock(blocks[activeBlock]);
  }, [activeBlock, blocks]);
  const returnTypeBlock = (item: IProductPremiumSingleBlock<IProductPremiumDescriptionVariantBlock | IProductPremiumArrangementVariantBlock | IProductPremiumProductDescriptionVariantBlock, IParsedImage>) => {
    if (isDescriptionVariant(item)) {
      return item;
    }
    if (isArrangementVariant(item)) {
      return item;
    }
    if (isProductDescriptionVariant(item)) {
      return item;
    }
    return item;
  };
  return {
    previousBlock: returnTypeBlock(previousBlock),
    currentBlock: returnTypeBlock(currentBlock),
    isDescriptionVariant,
    isArrangementVariant,
    isProductDescriptionVariant
  };
};
export default useProductPremiumSlide;